import 'bootstrap/dist/css/bootstrap.min.css'

import './assets/theme.scss'

import './icons'

const Theme = (props) => props.children

export default Theme
